import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  const [openId, setOpenId] = useState<number>(1);

  const toggle = (id: number) => {
    setOpenId(openId === id ? 0 : id);
  };

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          关于被窝影院的追剧体验，你想知道的都在这里
        </p>

        <div className="space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="rounded-xl border border-background-200 bg-background-50 overflow-hidden transition-all"
            >
              <button
                onClick={() => toggle(item.id)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/60 transition-colors"
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {item.question}
                </h3>
                <span className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full transition-transform duration-300 ${openId === item.id ? 'bg-primary-500 text-background-50 rotate-180' : 'bg-background-200 text-foreground-500'}`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </span>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openId === item.id ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-4 text-sm text-foreground-500 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}